// extracted by mini-css-extract-plugin
export default {"tileBody":"TileBody_tileBody__QPg1-"};